import * as React from "react";
import FlexLayout from "../../../controls/FlexLayout";
import { Button } from "react-bootstrap";
import Image from "../../../controls/Image";
const electricBoltIconPath = "assets/icons/electric-bolt.svg";
const premiumPictogramPath = "assets/pictograms/premium-pictogram.svg";
const freePictogramPath = "assets/pictograms/free-pictogram.svg";
function NewFreeDownloadModal(props) {
    const { t, fileInfo, openModPage, goPremium, onDownload, positionText } = props;
    return (React.createElement("div", null,
        React.createElement(FlexLayout, { type: "column", id: "content-container" },
            React.createElement(FlexLayout.Fixed, null, fileInfo !== null ? (React.createElement(FlexLayout, { type: "row", id: "top-row" },
                React.createElement(FlexLayout.Fixed, null,
                    React.createElement(Image, { id: "mod-thumbnail", srcs: [fileInfo.mod.pictureUrl] })),
                React.createElement(FlexLayout.Flex, null,
                    React.createElement(FlexLayout, { type: "column" },
                        React.createElement("div", { id: "mod-name" }, fileInfo.mod.name),
                        React.createElement("div", { id: "mod-author" },
                            "by ",
                            fileInfo.mod.uploader.name))),
                React.createElement(FlexLayout.Fixed, null,
                    React.createElement("div", { id: "mod-count" }, positionText)))) : (React.createElement(FlexLayout, { type: "row", id: "top-row" },
                React.createElement(FlexLayout.Fixed, null,
                    React.createElement("div", null, "Loading..."))))),
            React.createElement(FlexLayout.Fixed, null,
                React.createElement(FlexLayout, { type: "row", id: "bottom-row" },
                    React.createElement(FlexLayout.Flex, null,
                        React.createElement(FlexLayout, { type: "column", id: "free-container" },
                            React.createElement(Image, { className: "free-pictogram", srcs: [freePictogramPath] }),
                            React.createElement("div", { className: "membership-type" }, "Free"),
                            React.createElement("div", { className: "title" }, "Download one by one"),
                            React.createElement("hr", null),
                            React.createElement("ul", null,
                                React.createElement("li", null, "Manual download for collections"),
                                React.createElement("li", null, "Throttled download speeds (3 MB/s)"),
                                React.createElement("li", null, "Ads and delay for each download")),
                            React.createElement(Button, { id: "download-mod-button", onClick: onDownload }, t("Download manually")))),
                    React.createElement(FlexLayout.Flex, null,
                        React.createElement(FlexLayout, { type: "column", id: "premium-container" },
                            React.createElement(Image, { className: "premium-pictogram", srcs: [premiumPictogramPath] }),
                            React.createElement("div", { className: "membership-type" }, "Premium"),
                            React.createElement("div", { className: "title" }, "Get all your mods fast"),
                            React.createElement("hr", null),
                            React.createElement("ul", null,
                                React.createElement("li", null, "Auto-download collections"),
                                React.createElement("li", null, "Max download speeds"),
                                React.createElement("li", null, "No more ads")),
                            React.createElement(Button, { id: "get-premium-button", onClick: goPremium },
                                React.createElement(Image, { srcs: [electricBoltIconPath] }),
                                t("Auto-download all")))))))));
}
export default NewFreeDownloadModal;
